@if (
  {
    isDrawerVisible: activityDrawerService.isVisible(),
    selectedActivity: selectedActivity(),
    selectedShift: selectedShift$ | async,
    activityCategories: activityCategories$ | async,
  };
  as data
) {
  @if (data.isDrawerVisible) {
    <nz-drawer
      [nzVisible]="true"
      [nzMask]="true"
      [nzMaskClosable]="true"
      [nzMaskStyle]="{ backgroundColor: 'transparent' }"
      nzPlacement="right"
      [nzTitle]="
        'activity_like_bulk_edit.drawer.header.activity_templates.one'
          | translate
      "
      [nzFooter]="drawerFooter"
      [nzClosable]="false"
      (nzOnClose)="closeDrawer()"
    >
      <ng-container *nzDrawerContent>
        @if (!isLoading() && !isError()) {
          @if (data.selectedActivity) {
            <wilson-activity-drawer-form
              [isDisabled]="
                !!data.selectedActivity.jobId ||
                data.selectedActivity.operationalStatus !==
                  OperationStatus.NotStarted ||
                data.selectedActivity.createdFrom === WilsonApp.Mobile
              "
              [activity]="data.selectedActivity"
              [isDrawerOpened]="true"
              [activities]="data.selectedShift?.activities || []"
              [activityCategories]="data.activityCategories || []"
              (updateActivity)="updateActivity()"
              (value)="formValue = $event"
            ></wilson-activity-drawer-form>
            <wilson-activity-drawer-actions-section
              class="mt-2"
              [isAllDisabled]="isLoading()"
              [activity]="data.selectedActivity"
              [shift]="data.selectedShift"
              [activityCategories]="data.activityCategories || []"
              [activityUserId]="activityUserId"
              [isLastActivityInShift]="!!isLastActivity()"
              (delete)="handleDeletion(selectedActivity(), !!isLastActivity())"
              (closeDrawer)="closeDrawer()"
            >
            </wilson-activity-drawer-actions-section>
          }
        } @else if (isLoading()) {
          <nz-skeleton
            [nzActive]="true"
            [nzParagraph]="{ rows: 10 }"
          ></nz-skeleton>
        } @else if (isError()) {
          <nz-alert
            [nzType]="'error'"
            [nzMessage]="'general.error' | translate"
          ></nz-alert>
        }
      </ng-container>
      <ng-template #drawerFooter>
        <div class="drawer__footer">
          <wilson-last-update-status
            [updatedAt]="updatedAt"
            [isUpdated]="isSuccessfullySaved()"
          ></wilson-last-update-status>
        </div>
      </ng-template>
    </nz-drawer>
  }
}
